var _rect, _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgImagesSelected = function SvgImagesSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    rx: 8.533,
    fill: "url(#Images_Selected_svg__paint0_radial_630_41936)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 11,
    r: 3,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.264 20.039c.767-1.344 2.705-1.344 3.473 0l4.553 7.969c.762 1.333-.2 2.992-1.736 2.992h-9.108c-1.535 0-2.498-1.659-1.736-2.992l4.553-7.97z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.506 18c.77-1.333 2.694-1.333 3.464 0l5.773 10c.77 1.333-.192 3-1.732 3H17.464c-1.54 0-2.502-1.667-1.732-3l5.774-10z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Images_Selected_svg__paint0_radial_630_41936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(65.761 -4.2 12.361) scale(27.2905 28.3851)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgImagesSelected;